<template>
    <div class="px-2 pb-2 pt-1">
        <validation-observer #default="{ invalid }">
            <b-form @submit.prevent>
                <div class="mt-25">
                    <b-form-group label="دسته‌بندی" label-for="nameEnId">
                        <b-form-input :value="data ? data.name_Fa : null" disabled></b-form-input>
                    </b-form-group>
                </div>
                <div class="mt-25">
                    <b-form-group label="نام" label-for="nameId">
                        <validation-provider #default="{ errors }" name="نام" rules="required">
                            <b-form-input v-model="form.Name_Fa"
                                :state="errors.length > 0 ? false : null"></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </div>
                <div class="mt-25">
                    <b-form-group label="نام انگلیسی" label-for="nameEnId">
                        <b-form-input v-model="form.Name_En"></b-form-input>
                    </b-form-group>
                </div>
                <div class="mt-25">
                    <b-form-group label="توضیحات" label-for="descriptionId">
                        <b-form-textarea rows="3" no-resize dir="rtl" class="text-primary-middle"
                            v-model="form.description"></b-form-textarea>
                    </b-form-group>
                </div>
                <div class="mt-2">
                    <b-button type="submit" variant="primary" @click="addCategories" :disabled="invalid || loading"
                        class="d-flex align-items-center justify-content-center w-100">
                        <span>افزودن</span>
                        <b-spinner v-if="loading" class="ml-50" variant="white" small></b-spinner>
                    </b-button>
                </div>
            </b-form>
        </validation-observer>
    </div>
</template>


<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BFormRadio, BForm, BFormInput, BFormFile, BFormGroup, BSpinner, BTable, BAvatar, BImg, BFormTextarea } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from '@validations';
import { storeService } from '@core/services';

export default {
    components: {
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BForm,
        BFormInput,
        BFormFile,
        BSpinner,
        BTable,
        BAvatar,
        BFormTextarea,
        BFormRadio,
        BImg,
        BFormGroup,
        ValidationProvider,
        ValidationObserver
    },
    props: {
        data: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            required,
            storeId: null,
            loading: false,
            form: {
                Name_Fa: null,
                Name_En: null,
                description: null,
                DefaultCategoryIconId: null,
                CategoryIconImage: null,
            },
        }
    },
    methods: {
        addCategories() {
            this.loading = true;
            let formData = new FormData();
            formData.append("Name_Fa", this.form.Name_Fa)
            this.form.Name_En ? formData.append("Name_En", this.form.Name_En) : null
            this.form.description ? formData.append("description", this.form.description) : null
            this.form.DefaultCategoryIconId ? formData.append("DefaultCategoryIconId", this.form.DefaultCategoryIconId) : null
            this.form.CategoryIconImage ? formData.append("CategoryIconImage", this.form.CategoryIconImage, this.form.CategoryIconImage.name) : null
            formData.append("ParentId", this.data.id)
            storeService.createCategory(this.storeId, formData).then(({ data }) => {
                this.$emit('addSubCategories');
                this.$notif({ type: 'success', title: 'زیردسته با موفقیت اضافه شد' });
            })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
    },
};
</script>